import type { Ref } from "vue";
import type { Requests } from "../common/request.common";
import type { SettingsResponseTypes } from "../common/response.common";
import { asUpdateHook, get, post } from "./common";

export const settings = {
    clientConfig() {
        return get<SettingsResponseTypes.Client>(`/settings/client`, { authenticated: false });
    },
    finance() {
        return get<SettingsResponseTypes.ObtainFinance>(`/settings/obtain/finance`);
    },
    profile() {
        return get<SettingsResponseTypes.ObtainProfile>(`/settings/obtain/profile`);
    },
    whatsApp() {
        return get<SettingsResponseTypes.ObtainWhatsApp>(`/settings/obtain/whatsapp`);
    },
    firebase() {
        return get<SettingsResponseTypes.ObtainFirebase>(`/settings/obtain/firebase`);
    },
    xendit() {
        return get<SettingsResponseTypes.ObtainXendit>(`/settings/obtain/xendit`);
    },
    mobile() {
        return get<SettingsResponseTypes.ObtainMobile>(`/settings/obtain/mobile`);
    },
    toggleXenditMethod(data: typeof Requests.Settings.XenditMethod.Input) {
        return post<typeof data>(`/settings/update/xendit-method`, data);
    },
    xenditPendingTransactions() {
        return get<SettingsResponseTypes.ObtainXenditTransactions>(
            `/settings/obtain/xendit-transactions`,
        );
    },
    formHooks: {
        updateFinance(isLoading?: Ref<boolean>) {
            return async (data: typeof Requests.Settings.FinanceSettings.Input) => {
                return await asUpdateHook(
                    post<typeof data>(`/settings/update/finance`, data),
                    isLoading,
                );
            };
        },
        updateProfile(isLoading?: Ref<boolean>) {
            return async (data: typeof Requests.Settings.ProfileSettings.Input) => {
                return await asUpdateHook(
                    post<typeof data>(`/settings/update/profile`, data),
                    isLoading,
                );
            };
        },
        updateWhatsApp(isLoading?: Ref<boolean>) {
            return async (data: typeof Requests.Settings.WhatsAppSettings.Input) => {
                return await asUpdateHook(
                    post<typeof data>(`/settings/update/whatsapp`, data),
                    isLoading,
                );
            };
        },
        updateFirebase(isLoading?: Ref<boolean>) {
            return async (data: typeof Requests.Settings.FirebaseSettings.Input) => {
                return await asUpdateHook(
                    post<typeof data>(`/settings/update/firebase`, data),
                    isLoading,
                );
            };
        },
        updateXendit(isLoading?: Ref<boolean>) {
            return async (data: typeof Requests.Settings.XenditSettings.Input) => {
                return await asUpdateHook(
                    post<typeof data>(`/settings/update/xendit`, data),
                    isLoading,
                );
            };
        },
        updateMobile(isLoading?: Ref<boolean>) {
            return async (data: typeof Requests.Settings.MobileSettings.Input) => {
                return await asUpdateHook(
                    post<typeof data>(`/settings/update/mobile`, data),
                    isLoading,
                );
            };
        },
    },
};
